function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon/sf-small/overview/white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  x: 1,
  y: 1,
  width: 7,
  height: 7,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  x: 1,
  y: 12,
  width: 7,
  height: 7,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  x: 12,
  y: 1,
  width: 7,
  height: 7,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-3",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  x: 12,
  y: 12,
  width: 7,
  height: 7,
  rx: 2
}));

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.1ca0dea7.svg";
export { ForwardRef as ReactComponent };